import type { IAddress } from "@bbj-types/address";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosUser } from "./axios";
import type { INotificationPreferences, NotificationPreferenceFeature } from "./me";

export interface TPatchUserMeBody {
  lastName?: string;
  firstName?: string;
  position?: string;
  phone?: string;
  isDisabled?: boolean;
  department?: string;
  departmentPhone?: string;
  departmentEmail?: string;
  manager?: ObjectId | null;
  notificationPreferences?: Record<NotificationPreferenceFeature, INotificationPreferences>;
  shareEmail: boolean;
  sharePhone: boolean;
  favoriteAddresses?: IAddress[];
}

export const usePatchUserMe = () => {
  const [state, execute, cancel] = axiosUser<void, TPatchUserMeBody, unknown>(
    {
      method: "PATCH",
      withCredentials: true,
      url: "me",
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: TPatchUserMeBody) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
